import {PageRequest} from '../core/pagination/page-request';
import {Client} from './client';
import {SortOrder} from '../core/sort/sort-order';
import {ClientenFilter} from './clienten/filter/clienten-filter';

export class ClientPageRequest extends PageRequest<Client> {

  static firstClientenPageRequest(sortOrder: SortOrder, pageSize: number): ClientPageRequest {
    return new ClientPageRequest(
      sortOrder === SortOrder.ASCENDING,
      pageSize,
      1,
      0,
    );
  }

  static clientFilterRequest(clientFilter: ClientenFilter, pageRequest: PageRequest<Client>): ClientPageRequest {
    return new ClientPageRequest(
      pageRequest.ascending,
      pageRequest.pageSize,
      1,
      0,
      undefined,
      undefined,
      clientFilter.getClientnummer(),
      clientFilter.getZoneId(),
      clientFilter.getDienstId(),
      clientFilter.getClientAchternaam(),
    );
  }

  constructor(
    ascending: boolean,
    pageSize: number,
    pageNumber: number,
    previousPageNumber: number,
    firstItemPreviousPage?: Client,
    lastItemPreviousPage?: Client,
    public clientnummer?: string,
    public zoneId?: string,
    public dienstId?: string,
    public clientAchternaam?: string,
  ) {
    super(ascending, pageSize, pageNumber, previousPageNumber, firstItemPreviousPage, lastItemPreviousPage);
  }

  withSortOrder(sortOrder: SortOrder): ClientPageRequest {
    return this.forPageRequest(ClientPageRequest.firstClientenPageRequest(sortOrder, this.getPageSize()));
  }

  withPageSize(pageSize: number): ClientPageRequest {
    return this.forPageRequest(ClientPageRequest.firstClientenPageRequest(this.getSortOrder(), pageSize));
  }

  forPageRequest(pageRequest: PageRequest<Client>): ClientPageRequest {
    return new ClientPageRequest(
      pageRequest.ascending,
      pageRequest.pageSize,
      pageRequest.pageNumber,
      pageRequest.previousPageNumber,
      pageRequest.firstItemPreviousPage,
      pageRequest.lastItemPreviousPage,
      this.clientnummer,
      this.zoneId,
      this.dienstId,
      this.clientAchternaam,
    );
  }
}
